function saveNextUrlInSamlLogin(path: string, url = ''): string {
  if (url.split('/password').length > 1 || url.split('/login').length > 1) {
    return `/API/auth/v1/auth/saml/sso/${path}/`;
  }
  return `/API/auth/v1/auth/saml/sso/${path}/?next=${url}`;
}

export function refreshSamlSession(): void {
  window.location.replace(
    saveNextUrlInSamlLogin(
      window.localStorage.samlSession,
      window.location.pathname,
    ),
  );
}

export function getSamlSession(): string {
  return window.localStorage.samlSession;
}

export function destroySamlSession(): void {
  window.localStorage.removeItem('samlSession');
}

export type SamlSessionData = {
  user_id?: string;
  app_id?: string;
  token?: string;
  session_key?: string;
  system_domain_id?: string;
  system_domain_status?: string;
  identity_provider_id?: string;
};

export function setSamlSession(data: SamlSessionData): void {
  if (data.system_domain_id && data.identity_provider_id) {
    window.localStorage.samlSession = `${data.system_domain_id}/${data.identity_provider_id}`;
  } else if (data.session_key) {
    window.localStorage.samlSession = data.session_key;
  } else {
    destroySamlSession();
  }
}
